export const routes = {
    dashboard: {
        path: "dashboard",
    },
    settings: {
        path: "settings",
    },
    elements: {
        path: "elements",
    },
    license: {
        path: "license",
    }
}